"use client";
import {
  useComboboxProviderContext
} from "./WJUQFF4Z.js";
import {
  useCompositeStoreProps
} from "./HVBTERMS.js";
import {
  usePopoverStoreProps
} from "./BJY6QMBB.js";
import {
  useStore,
  useStoreProps
} from "./S67MTDSB.js";
import {
  useUpdateEffect
} from "./FPBGCFAS.js";
import {
  __spreadProps,
  __spreadValues
} from "./4R3V3JGP.js";

// src/select/select-store.ts
import * as Core from "@ariakit/core/select/select-store";
function useSelectStoreProps(store, update, props) {
  useUpdateEffect(update, [props.combobox]);
  useStoreProps(store, props, "value", "setValue");
  useStoreProps(store, props, "setValueOnMove");
  return Object.assign(
    usePopoverStoreProps(
      useCompositeStoreProps(store, update, props),
      update,
      props
    ),
    { combobox: props.combobox }
  );
}
function useSelectStore(props = {}) {
  const combobox = useComboboxProviderContext();
  props = __spreadProps(__spreadValues({}, props), {
    combobox: props.combobox !== void 0 ? props.combobox : combobox
  });
  const [store, update] = useStore(Core.createSelectStore, props);
  return useSelectStoreProps(store, update, props);
}

export {
  useSelectStoreProps,
  useSelectStore
};
